import React, { Fragment } from "react";
import { Modal, ModalHeader, ModalBody, Table, Badge, Card, CardBody, Row, Col } from "reactstrap";
import convertToRupees from "../../../../../utilities/convertToRupees";
import formatedDate from "../../../../../utilities/formatedDate";
import { stat } from "fs";

const BulkInvoiceDocumentsModal = ({ isOpen, toggle, invoiceData , invoiceStatus }) => {
  if (!invoiceData) return null;
  console.log("invoiceData in modal", invoiceStatus);
  const documents = invoiceData?.documentTxnList || [];
  const documentDetails = invoiceData?.documentDetails || invoiceData || [];

  const isCancelledStatus = (status, invStatus) => {
    const normalizedStatus = String(status || '').toUpperCase();
    const normalizedInvoiceStatus = String(invStatus || '').toUpperCase();

    return normalizedStatus === 'CANCELLED' || normalizedStatus === 'CANCELED' || normalizedInvoiceStatus === 'CANCELLED' || normalizedInvoiceStatus === 'CANCELED';
  };

  const effectiveAmount = (amount, status) => {
    const numericAmount = Number(amount || 0);
    return isCancelledStatus(status, invoiceStatus) ? 0 : numericAmount;
  };

  const displayAmount = (amount) => Number(amount || 0);

  const summaryBaseAmount = documents.length > 0
    ? documents.reduce((sum, doc) => sum + effectiveAmount(doc.memberPremium, doc?.status), 0)
    : Number(invoiceData.total_premium_amount || 0);

  const summaryCommissionAmount = documents.length > 0
    ? documents.reduce((sum, doc) => sum + effectiveAmount(doc.commissionAmount, doc?.status), 0)
    : Number(invoiceData.total_commission_amount || 0);

  const summaryGstAmount = documents.length > 0
    ? documents.reduce((sum, doc) => sum + effectiveAmount(doc.gstAmount, doc?.status), 0)
    : Number(invoiceData.gst_amount || 0);

  const summaryTdsAmount = documents.length > 0
    ? documents.reduce((sum, doc) => sum + effectiveAmount(doc.tdsAmount, doc?.status), 0)
    : Number(invoiceData.tds_amount || 0);

  const summaryNetPayableAmount = documents.length > 0
    ? documents.reduce((sum, doc) => sum + effectiveAmount(doc.netPayableAmt, doc?.status), 0)
    : Number(invoiceData.net_payable_amount || 0);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle} style={{ backgroundColor: '#00239c', color: '#fff', borderBottom: 'none', position: 'relative' }}>
        {/* Custom style for close button */}
        <style>{`.modal-header .close { color: #fff !important; opacity: 1; }`}</style>
        <div>
          <h5 className="mb-0" style={{ fontWeight: '600', letterSpacing: '0.5px' }}>Invoice Documents Details</h5>
        </div>
      </ModalHeader>
      <ModalBody className="p-4" style={{ backgroundColor: '#f8f9fa' }}>
        {/* Invoice Summary Card */}
        <Card className="mb-4 shadow-sm" style={{ border: '1px solid #dee2e6', borderRadius: '8px' }}>
          <CardBody style={{ backgroundColor: '#fff', padding: '20px', borderLeft: '4px solid #00239c' }}>
            <Row className="align-items-center">
              <Col md={3}>
                <div className="mb-2">
                  <small className="d-block mb-1" style={{ color: '#6c757d', fontSize: '11px', fontWeight: '500' }}>Invoice Number</small>
                  <h6 className="mb-0" style={{ color: '#00239c', fontSize: '16px', fontWeight: '700', letterSpacing: '0.5px' }}>
                    {invoiceData.invoice_number}
                  </h6>
                </div>
              </Col>
              <Col md={2}>
                <div className="mb-2">
                  <small className="d-block mb-1" style={{ color: '#6c757d', fontSize: '11px', fontWeight: '500' }}>Documents</small>
                  <Badge color="primary" className="px-3 py-2" style={{ fontSize: '14px', fontWeight: '700', backgroundColor: '#00239c' }}>
                    {invoiceData.total_documents}
                  </Badge>
                </div>
              </Col>
              <Col md={2}>
                <div className="mb-2">
                  <small className="d-block mb-1" style={{ color: '#6c757d', fontSize: '11px', fontWeight: '500' }}>Wallet Type</small>
                  <Badge color="info" className="px-3 py-2" style={{ fontSize: '14px', fontWeight: '700' }}>
                    {invoiceData.walletType || "N/A"}
                  </Badge>
                </div>
              </Col>
              <Col md={2}>
                <div className="mb-2">
                  <small className="d-block mb-1" style={{ color: '#6c757d', fontSize: '11px', fontWeight: '500' }}>Base Amount</small>
                  <h6 className="mb-0" style={{ color: '#212529', fontSize: '16px', fontWeight: '700' }}>
                    {convertToRupees(summaryBaseAmount || 0)}
                  </h6>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-2">
                  <small className="d-block mb-1" style={{ color: '#6c757d', fontSize: '11px', fontWeight: '500' }}>Net Payable</small>
                  <h5 className="mb-0" style={{ color: summaryNetPayableAmount < 0 ? '#dc3545' : '#28a745', fontSize: '20px', fontWeight: '800' }}>
                    {convertToRupees(summaryNetPayableAmount || 0)}
                  </h5>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Documents Table */}
        <div className="mb-3">
          <h6 className="mb-3" style={{ color: '#00239c', fontWeight: '700', fontSize: '16px', borderBottom: '2px solid #00239c', paddingBottom: '8px' }}>
            Documents Breakdown
          </h6>
          <div className="table-responsive" style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
            <Table bordered hover className="mb-0" style={{ fontSize: '13px', backgroundColor: '#fff' }}>
              <thead style={{ color: '#fff' }}>
                <tr>
                  <th style={{ width: '40px', padding: '12px 8px', fontWeight: '600' }}>#</th>
                  <th style={{ padding: '12px 8px', fontWeight: '600' }}>Document No</th>
                  <th style={{ padding: '12px 8px', fontWeight: '600' }}>Traveller Name</th>
                  <th style={{ padding: '12px 8px', fontWeight: '600' }}>Plan</th>
                  <th className="text-end" style={{ padding: '12px 8px', fontWeight: '600' }}>Base Amount</th>
                  <th className="text-end" style={{ padding: '12px 8px', fontWeight: '600' }}>Commission</th>
                  <th className="text-end" style={{ padding: '12px 8px', fontWeight: '600' }}>GST</th>
                  <th className="text-end" style={{ padding: '12px 8px', fontWeight: '600' }}>TDS</th>
                  <th className="text-end" style={{ padding: '12px 8px', fontWeight: '600' }}>Net Payable</th>
                  <th className="text-center" style={{ padding: '12px 8px', fontWeight: '600' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {documents.length > 0 ? (
                  documents.map((doc, index) => {
                    const isCancelled = isCancelledStatus(doc?.status , invoiceStatus);
                    const rowBaseAmount = displayAmount(doc.memberPremium);
                    const rowCommissionAmount = displayAmount(doc.commissionAmount);
                    const rowGstAmount = displayAmount(doc.gstAmount);
                    const rowTdsAmount = displayAmount(doc.tdsAmount);
                    const rowNetPayableAmount = displayAmount(doc.netPayableAmt);
                    const traveller = doc?.traveller
                    const firstName = traveller?.firstName || "";
                    const middleName = traveller?.middleName || "";
                    const lastName = traveller?.lastName || "";
                    const travellerName = [firstName, middleName, lastName].filter(Boolean).join(" ") || "N/A";

                    return (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa' }}>
                      <td className="text-center" style={{ padding: '10px 8px', fontWeight: '600', color: '#495057' }}>{index + 1}</td>
                      <td style={{ padding: '10px 8px' }}>
                        <span style={{ color: '#00239c', fontWeight: '700', fontSize: '13px' }}>
                          {doc.documentCode || "N/A"}
                        </span>
                      </td>
                      <td style={{ padding: '10px 8px', fontWeight: '500', color: '#333' }}>{travellerName}</td>
                      <td style={{ padding: '10px 8px', fontWeight: '500', color: '#333' }}>{doc.plan?.title || "N/A"}</td>
                      <td className="text-end" style={{ padding: '10px 8px', fontWeight: '600', color: isCancelled ? '#dc3545' : '#333' }}>
                        {convertToRupees(rowBaseAmount || 0)}
                      </td>
                      <td className="text-end" style={{ padding: '10px 8px', fontWeight: '600', color: isCancelled ? '#dc3545' : '#333' }}>
                        {convertToRupees(rowCommissionAmount || 0)}
                      </td>
                      <td className="text-end" style={{ padding: '10px 8px', fontWeight: '600', color: isCancelled ? '#dc3545' : '#333' }}>
                        {convertToRupees(rowGstAmount || 0)}
                      </td>
                      <td className="text-end" style={{ padding: '10px 8px', fontWeight: '600', color: isCancelled ? '#dc3545' : '#333' }}>
                        {convertToRupees(rowTdsAmount || 0)}
                      </td>
                      <td className="text-end" style={{ padding: '10px 8px', fontWeight: '700', color: isCancelled ? '#dc3545' : '#28a745', fontSize: '14px' }}>
                        {convertToRupees(rowNetPayableAmount || 0)}
                      </td>
                      <td className="text-center" style={{ padding: '10px 8px' }}>
                        <Badge
                          color={
                              isCancelled
                                ? "danger"
                                : String(invoiceStatus || "").toUpperCase() === "PAID"
                                  ? "success"
                                  : String(invoiceStatus || "").toUpperCase() === "PENDING_FOR_COMMISSION"
                                    ? "warning"
                                    : String(invoiceStatus || "").toUpperCase() === "PENDING_FROM_FINANCE"
                                      ? "warning"
                                      : "warning"
                            }
                          className="px-3 py-1"
                          style={{ fontSize: '11px', fontWeight: '600', textTransform: 'uppercase' }}
                        >
                          { isCancelled
                            ? "cancelled"
                            : (invoiceStatus || doc?.status || "NA").replace(/_/g, ' ')}
                        </Badge>
                      </td>
                    </tr>
                  );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-4" style={{ color: '#999', fontStyle: 'italic' }}>
                      No documents found
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot style={{ color: '#fff', fontWeight: 'bold' }}>
                <tr>
                  <td colSpan="3" className="text-end" style={{ padding: '12px 8px', fontSize: '14px', fontWeight: '700' }}>Totals:</td>
                  <td className="text-end" style={{ padding: '12px 8px', fontSize: '14px', fontWeight: '700' }}>
                    {convertToRupees(summaryBaseAmount || 0)}
                  </td>
                  <td className="text-end" style={{ padding: '12px 8px', fontSize: '14px', fontWeight: '700' }}>
                    {convertToRupees(summaryCommissionAmount || 0)}
                  </td>
                  <td className="text-end" style={{ padding: '12px 8px', fontSize: '14px', fontWeight: '700' }}>
                    {convertToRupees(summaryGstAmount || 0)}
                  </td>
                  <td className="text-end" style={{ padding: '12px 8px', fontSize: '14px', fontWeight: '700' }}>
                    {convertToRupees(summaryTdsAmount || 0)}
                  </td>
                  <td className="text-end" style={{ padding: '12px 8px', fontSize: '15px', fontWeight: '800', color: summaryNetPayableAmount < 0 ? '#dc3545' : '#28a745' }}>
                    {convertToRupees(summaryNetPayableAmount || 0)}
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default BulkInvoiceDocumentsModal;
